import { Box, Table, TableRow, TopBar } from '@sam/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { updateSchambeckUserTableConfig, useData } from 'shared';
import { useMemo } from 'react';
import { convertFeedbackEntriesIntoTableEntries } from '../../utils/customerFeedbackEntry/CustomerFeedbackEntry.utils';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useUser } from '../../components/UserContext';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const CustomerFeedbackEntryOverview: React.FC = () => {
  const { t } = useTranslation();
  const { axios, updateContextUser, user } = useUser();
  const navigate = useNavigate();
  const { data: loadedFeedbackEntries } = useData('FEEDBACK_ALL', {
    config: { fallbackData: [] },
  });
  const { data: businessAreas } = useData('BUSINESSAREA_ALL', {
    config: { fallbackData: [] },
  });

  /**
   * TableRows containing all customerFeedbackEntries
   */
  const rows: TableRow[] = useMemo(
    (): TableRow[] =>
      convertFeedbackEntriesIntoTableEntries(loadedFeedbackEntries, navigate, businessAreas),
    [businessAreas, loadedFeedbackEntries, navigate],
  );
  return (
    <>
      <TopBar title={t('pages.customerFeedback.overview.topBarHeadline')}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('/customer/feedback/edit')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.FEEDBACK_ENTRY_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.FEEDBACK_ENTRY_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          rows={rows}
          header={
            t('pages.customerFeedback.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
